// Libs
import React, { useMemo } from 'react';

// Own Libs

//Api
import { getCrfFechamentExecutadoMesAnoByFechamentoId } from '@app/api/crf/crffechamento';

//Files
import TabelaExecutadoMesAno from './tabelaRegistroImportacao';
import { useRecoilState } from 'recoil';
import { listCrfRegistroEsin204Fechamento } from '@app/state/atom';
import { CrfRegistroEsin204Importacao } from '@app/api/crf/CrtRegistroEsin204';

//Utils

interface FechamentoModuloExecutadoTabelaProps {
    carregarTabela: boolean;
    ano: number;
    fechamentoId: string;
    meses: string[];
}

const FechamentoModuloExecutadoTabela = (props: FechamentoModuloExecutadoTabelaProps) => {

    const { carregarTabela, ano, fechamentoId, meses } = props
    const [listRegistroEsinResult, setlistRegistroEsinResult] = useRecoilState(listCrfRegistroEsin204Fechamento);

    useMemo(async () => {
        if (meses && meses.length) {
            let resultRegistroEsin204: Array<CrfRegistroEsin204Importacao> = new Array<CrfRegistroEsin204Importacao>;

            for (let index = 0; index < meses.length; index++) {
                const mes = meses[index];

                const data = await getCrfFechamentExecutadoMesAnoByFechamentoId(fechamentoId, mes, ano);
                if (data) {
                    resultRegistroEsin204.push(...data);
                }
            }
            setlistRegistroEsinResult(resultRegistroEsin204);
        }
    }, [carregarTabela]);

    return (

        <>
            {listRegistroEsinResult && listRegistroEsinResult.length > 0 ? (
                <>
                    <TabelaExecutadoMesAno />
                </>) :
                (
                    <> </>
                )
            }
        </>
    );

}

export default FechamentoModuloExecutadoTabela;

